/**
 * Consolidation feedback card — shows consolidation stage output.
 *
 * CSS: uses gate-card.css shared styles (.gate-expand, .gate-response, .gate-files)
 */

import { esc } from '../../shared/rendering.js'
import { action } from './action-delegation.js'
import type { ConsolidateCardProps } from '../../types/components.js'

/** Render a consolidation feedback card. Click expands to show full response. */
export function renderConsolidateCard(props: ConsolidateCardProps): string {
  const filesHtml = (props.files ?? []).map((f) => `<div class="gate-fi">${esc(f)}</div>`).join('')

  return `<div class="gate" role="button" tabindex="0" aria-expanded="false" style="background:var(--wrn-d);border-color:rgba(251,191,36,.15);border-left-color:var(--wrn)" ${action('toggleGateExpand')}>
    <div class="gate-h">
      <span class="gate-lbl" style="color:var(--wrn)">CONSOLIDATE</span>
      <span style="font-size:9px;color:var(--t4);margin-left:auto">&#9654;</span>
    </div>
    <div class="gate-det">${esc(props.feedback)}</div>
    <div class="gate-expand">
      ${props.response ? `<div class="gate-response">${esc(props.response)}</div>` : ''}
      ${filesHtml ? `<div class="gate-files">${filesHtml}</div>` : ''}
    </div>
  </div>`
}
